import {parseJWT} from '@utils/jwtUtils';
import {getRouteByPath} from '@utils/routeMatching';
import {mainRoutePaths, signerRoutePaths} from '@setup/routeConfigs';
import {AUTH_RECIPIENT_ROLE, AUTH_USER_ROLE} from '@constants/user';

export const getUserRoleFromToken = (accessToken) => {
    if (!accessToken) return null;
    try {
        const payload = parseJWT(accessToken);
        return payload?.role || null;
    } catch {
        return null;
    }
};

export const getIsRecipientFromPath = (path) => {
    const route = getRouteByPath(path, mainRoutePaths, signerRoutePaths);
    return route?.isSignerRoute || false;
};

export const getIsRecipient = (accessToken, path = null) => {
    const role = getUserRoleFromToken(accessToken);
    const checkPath = path || (typeof window !== 'undefined' ? window.location.pathname : null);

    if (role !== null) {
        const isRecipient = role === AUTH_RECIPIENT_ROLE;
        return isRecipient;
    }

    const isRecipientFromPath = checkPath ? getIsRecipientFromPath(checkPath) : false;
    return isRecipientFromPath;
};

export const getIsSender = (accessToken) => {
    const role = getUserRoleFromToken(accessToken);
    return role === AUTH_USER_ROLE;
};

export const getIsOnPublicRoute = (path = null) => {
    const checkPath = path || (typeof window !== 'undefined' ? window.location.pathname : null);
    if (!checkPath) {
        return false;
    }

    const route = getRouteByPath(checkPath, mainRoutePaths, signerRoutePaths);
    const isPublic = !!route && route.isPrivate === false;

    return isPublic;
};
